import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import { useState } from "react";

interface PasswordProps extends Omit<TextFieldProps, "variant"> {
  field: any;
  error?: boolean;
  helperText?: string;
}

const Password: React.FC<PasswordProps> = ({
  field,
  error,
  helperText,
  slotProps,
  autoComplete,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <TextField
      {...rest}
      {...field}
      name={field.name}
      inputRef={field.ref}
      autoComplete={autoComplete}
      onChange={field.onChange}
      variant="standard"
      fullWidth
      type={showPassword ? "text" : "password"}
      error={error}
      helperText={helperText}
      slotProps={{
        ...slotProps,
        inputLabel: {
          shrink: !!field.value || undefined,
          ...slotProps?.inputLabel,
        },
        input: {
          endAdornment: (
            <InputAdornment position="end">
              {field.value && (
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" tabIndex={-1}>
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              )}
            </InputAdornment>
          ),
          ...slotProps?.input,
        },
      }}
    />
  );
};

export default Password;
